import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faEnvelope, faPhone, faGlobe } from '@fortawesome/sharp-regular-svg-icons';

import {
	faBlanket,
	faCalendarDays,
	faTv,
	faCocktail,
	faShower,
	faWifi,
	faAirConditioner,
	faBed,
	faChevronDown,
	faArrowRightLong,
	faChevronCircleLeft,
	faChevronCircleRight,
	faChevronUp,
	faDoorOpen,
	faHotTubPerson,
	faCoffee,
	faUtensils,
	faWineGlass,
	faStore,
	faBicycle,
	faCroissant,
	faCouch,
	faTree,
	faWater,
	faBath,
	faLampDesk,
	faLink,
	faVault,
	faBuildingColumns,
	faSpa,
	faGolfFlagHole,
	faPersonHiking,
	faPersonSkiing,
	faMusic,
	faMasksTheater,
	faMicrophone,
	faBanSmoking,
} from '@fortawesome/pro-light-svg-icons';
import { faCircleCheck, faBars, faLocationDot, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { faPlay, faSearch, faStar, faQuoteLeft, faStarHalf } from '@fortawesome/pro-solid-svg-icons';
import {
	faFacebook,
	faFacebookSquare,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTwitter,
	faTiktok,
	faWhatsapp,
	faYoutube,
	faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faAirConditioner,
	faArrowRightLong,
	faBanSmoking,
	faBars,
	faBath,
	faBed,
	faBicycle,
	faBlanket,
	faBuildingColumns,
	faCalendarDays,
	faChevronCircleLeft,
	faChevronCircleRight,
	faChevronDown,
	faChevronUp,
	faCircleCheck,
	faCocktail,
	faCoffee,
	faCouch,
	faCroissant,
	faDoorOpen,
	faEnvelope,
	faFacebook,
	faFacebookSquare,
	faGlobe,
	faGolfFlagHole,
	faHotTubPerson,
	faInstagram,
	faLampDesk,
	faChevronCircleRight,
	faChevronDown,
	faChevronUp,
	faLinkedin,
	faLink,
	faLocationDot,
	faMasksTheater,
	faMicrophone,
	faMusic,
	faPersonHiking,
	faPersonSkiing,
	faPhone,
	faPinterest,
	faPlay,
	faQuoteLeft,
	faSearch,
	faShower,
	faSoundcloud,
	faSpa,
	faSpotify,
	faStar,
	faStarHalf,
	faStore,
	faTimes,
	faTree,
	faTv,
	faTiktok,
	faTwitter,
	faUtensils,
	faVault,
	faWater,
	faWhatsapp,
	faWifi,
	faWineGlass,
	faXTwitter,
	faYoutube,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
